// import { useState, useContext, useEffect } from "react";
// import Pagination from "../Pagination/Pagination";
// import moment from "moment";
// import loaderContext from "../../context/LoaderContext";
// import { Link } from "react-router-dom";
// import axios from "axios";
// import { baseUrl, localUrl } from "../../config/baseUrl";
// import { toast } from "react-toastify";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faSearch } from "@fortawesome/free-solid-svg-icons";

// export default function StudentListTable() {
//   const [searchTerm, setSearchTerm] = useState("");
//   const [userList, setUserList] = useState([]);
//   const [paginationDetails, setPaginationDetails] = useState({
//     currentPage: 0,
//     totalPages: 0,
//     totalItems: 0,
//   });
//   const [pageNumber, setPageNumber] = useState(1);
//   const [pageLimit] = useState(20);
//   const [totalPages, setTotalPages] = useState(1);

//   const { setLoader } = useContext(loaderContext);

//   useEffect(() => {
//     fetchLiveData();
//   }, [pageNumber]);

//   const fetchLiveData = async () => {
//     try {
//       setLoader(true);
//       const response = await axios.post(
//         // `${localUrl}/admin/users/list?page=${pageNumber}`,
//         `${baseUrl}/admin/users/list?page=${pageNumber}`,
//         { name: searchTerm },
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       if (response?.data.status) {
//         const data = response?.data?.data || [];
//         const pagination = response?.data?.pagination;

//         setUserList(data);

//         if (pagination) {
//           setPaginationDetails({
//             currentPage: pagination.currentPage,
//             totalPages: pagination.totalPages,
//             totalItems: pagination.totalUsers,
//           });
//           setTotalPages(pagination.totalPages);
//         }
//       } else {
//         toast(response?.data.message || "Failed to fetch users");
//       }
//     } catch (error) {
//       console.error("Fetch error:", error);
//       toast("Error fetching data");
//     } finally {
//       setLoader(false);
//     }
//   };

//   const handleStatus = async (id, newStatus) => {
//     try {

//       const res = await axios.patch(
//         // `${localUrl}/admin/users/status/${id}`,
//         `${baseUrl}/admin/users/status/${id}`,
//         { status: newStatus },
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       if (res?.data.status) {
//         fetchLiveData();
//         toast.success(res?.data.message || "Status updated");
//       } else {
//         toast.error("Failed to update status");
//       }
//     } catch (error) {
//       console.error("Status update error:", error);
//       toast.error("Failed to update status");
//     }
//   };

//   return (
//     <div className="cards user-list">
//       <div className="row">
//         <div className="col-lg-12">
//           <div className="bus-filter">
//             <div className="row justify-content-center align-items-center g-3">
//               <div className="col-md-6 text-start">
//                 <div className="search-container">
//                   <FontAwesomeIcon icon={faSearch} className="search-icon" />
//                   <input
//                     type="text"
//                     className="search-input"
//                     placeholder="Search user by name..."
//                     value={searchTerm}
//                     onChange={(e) => setSearchTerm(e.target.value)}
//                   />
//                 </div>
//               </div>
//               <div className="col-md-6 text-end">
//                 <h6 className="mb-0">
//                   Total Users: {paginationDetails.totalItems || 0}
//                 </h6>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="col-lg-12">
//           <div className="table table-responsive custom-table management-table">
//             <table className="table table-borderless">
//               <thead>
//                 <tr>
//                   <th>Sr No.</th>
//                   <th>Profile</th>
//                   <th>Name</th>
//                   <th>Mobile</th>
//                   <th>Gender</th>
//                   <th>Marital</th>
//                   <th>Created</th>
//                   <th>Status</th>
//                   <th>Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {userList.length > 0 ? (
//                   userList.map((user, index) => (
//                     <tr key={user.id}>
//                       <td>{index + 1}</td>
//                       <td>
//                         <img
//                           // src={`${localUrl}/${user?.profile_pic}`}
//                           src={`${baseUrl}/${user?.profile_pic}`}
//                           alt="profile"
//                           style={{ width: "60px" }}
//                         />
//                       </td>
//                       <td>{user?.name || "N/A"}</td>
//                       <td>{user?.mobile_number || "N/A"}</td>
//                       <td>{user?.gender || "N/A"}</td>
//                       <td>{user?.marital_status || "N/A"}</td>
//                       <td>{moment(user?.created).format("lll")}</td>
//                       <td>
//                         <select
//                           className="form-select"
//                           value={user.status || "Pending"}
//                           onChange={(e) =>
//                             handleStatus(user?.id, e.target.value)
//                           }
//                           style={{
//                             minWidth: "120px",
//                             textTransform: "capitalize",
//                           }}
//                         >
//                           <option value="Active">Active</option>
//                           <option value="Inactive">Inactive</option>
//                           <option value="Pending">Pending</option>
//                         </select>
//                       </td>
//                       <td>
//                         <div className="action-buttons">
//                           <Link
//                             to={`/user-view/${user?.id}`}
//                             className="action-btn edit-btn"
//                           >
//                             <i className="fa fa-eye"></i>
//                             <span className="tooltip-text">View</span>
//                           </Link>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="9" className="text-center">
//                       No users found.
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>

//             {totalPages > 1 && (
//               <Pagination
//                 pageNumber={pageNumber}
//                 setPageNumber={setPageNumber}
//                 pageLimit={pageLimit}
//                 paginationDetails={paginationDetails}
//                 totalPages={paginationDetails.totalPages}
//               />
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import { useState, useContext, useEffect } from "react";
import Pagination from "../Pagination/Pagination";
import moment from "moment";
import loaderContext from "../../context/LoaderContext";
import { Link } from "react-router-dom";
import axios from "axios";
import { baseUrl, localUrl } from "../../config/baseUrl";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

export default function StudentListTable() {
  const [searchTerm, setSearchTerm] = useState("");
  const [userList, setUserList] = useState([]);
  const [paginationDetails, setPaginationDetails] = useState({
    currentPage: 0,
    totalPages: 0,
    totalItems: 0,
  });
  const [pageNumber, setPageNumber] = useState(1);
  const [pageLimit] = useState(20);
  const [totalPages, setTotalPages] = useState(1);

  const { setLoader } = useContext(loaderContext);
  const [filters, setFilters] = useState({
    name: "",
    qualification: "",
    matrimonial_status: "",
    occupation: "",
    gotra: "",
    location: "",
    gender: "",
    marital_status: "",
  });

  // ✅ Fetch users whenever page number or search term changes
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      fetchLiveData();
    }, 500);
    return () => clearTimeout(delayDebounce);
  }, [filters, pageNumber]);

  const fetchLiveData = async () => {
    try {
      setLoader(true);

      const response = await axios.post(
        // `${localUrl}/admin/users/list?page=${pageNumber}`,
        `${baseUrl}/admin/users/list?page=${pageNumber}`,
        {
          ...filters,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response?.data.status) {
        const data = response?.data?.data || [];
        const pagination = response?.data?.pagination;

        setUserList(data);

        if (pagination) {
          setPaginationDetails({
            currentPage: pagination.currentPage,
            totalPages: pagination.totalPages,
            totalItems: pagination.totalUsers,
          });
          setTotalPages(pagination.totalPages);
        }
      } else {
        toast.error(response?.data.message || "Failed to fetch users");
      }
    } catch (error) {
      console.error("Fetch error:", error);
      toast.error("Error fetching data");
    } finally {
      setLoader(false);
    }
  };

  const handleStatus = async (id, newStatus) => {
    try {
      const res = await axios.patch(
        `${baseUrl}/admin/users/status/${id}`,
        { status: newStatus },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (res?.data.status) {
        fetchLiveData();
        toast.success(res?.data.message || "Status updated");
      } else {
        toast.error("Failed to update status");
      }
    } catch (error) {
      console.error("Status update error:", error);
      toast.error("Failed to update status");
    }
  };

  return (
    <div className="cards user-list">
      <div className="bus-filter mb-3">
        <div className="row g-3 align-items-center">
          {/* 🔍 Name Search */}
          {/* <div className="col-md-3">
            <div className="search-container">
              <FontAwesomeIcon icon={faSearch} className="search-icon" />
              <input
                type="text"
                className="search-input"
                placeholder="Search by name..."
                value={filters.name}
                onChange={(e) =>
                  setFilters({ ...filters, name: e.target.value }) ||
                  setPageNumber(1)
                }
              />
            </div>
          </div> */}

          {/* 🎓 Qualification */}
          {/* <div className="col-md-2">
            <select
              className="form-select"
              value={filters.qualification}
              onChange={(e) =>
                setFilters({ ...filters, qualification: e.target.value }) ||
                setPageNumber(1)
              }
            >
              <option value="">All Qualifications</option>
              <option value="Bachelors">Bachelors</option>
              <option value="Masters">Masters</option>
              <option value="PhD">PhD</option>
            </select>
          </div> */}

          {/* 💍 Matrimonial Status */}
          <div className="col-md-2">
            <select
              className="form-select"
              value={filters.matrimonial_status}
              onChange={(e) =>
                setFilters({
                  ...filters,
                  matrimonial_status: e.target.value,
                }) || setPageNumber(1)
              }
            >
              <option value="">All Status</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>
          <div className="col-md-2">
            <select
              className="form-select"
              value={filters.marital_status}
              onChange={(e) =>
                setFilters({
                  ...filters,
                  marital_status: e.target.value,
                }) || setPageNumber(1)
              }
            >
              <option value="">Marital_status</option>
              <option value="Single">Single</option>
              <option value="Married">Married</option>
            </select>
          </div>

          {/* 🧑‍💼 Occupation */}
          {/* <div className="col-md-2">
            <select
              className="form-select"
              value={filters.occupation}
              onChange={(e) =>
                setFilters({ ...filters, occupation: e.target.value }) ||
                setPageNumber(1)
              }
            >
              <option value="">All Occupations</option>
              <option value="Engineer">Engineer</option>
              <option value="Doctor">Doctor</option>
              <option value="Teacher">Teacher</option>
            </select>
          </div> */}

          {/* 👨 Gotra */}
          <div className="col-md-2">
            <input
              type="text"
              className="form-control"
              placeholder="Gotra"
              value={filters.gotra}
              onChange={(e) =>
                setFilters({ ...filters, gotra: e.target.value }) ||
                setPageNumber(1)
              }
            />
          </div>

          {/* 📍 Location */}
          <div className="col-md-2">
            <input
              type="text"
              className="form-control"
              placeholder="Location"
              value={filters.location}
              onChange={(e) =>
                setFilters({ ...filters, location: e.target.value }) ||
                setPageNumber(1)
              }
            />
          </div>

          {/* 🚻 Gender */}
          <div className="col-md-2">
            <select
              className="form-select"
              value={filters.gender}
              onChange={(e) =>
                setFilters({ ...filters, gender: e.target.value }) ||
                setPageNumber(1)
              }
            >
              <option value="">All Genders</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </select>
          </div>

          {/* <button
            className="btn btn-secondary btn-sm ms-2"
            style={{

            }}
            onClick={() =>
              setFilters({
                name: "",
                qualification: "",
                matrimonial_status: "",
                occupation: "",
                gotra: "",
                location: "",
                gender: "",
              })
            }
          >
            Clear Filters
          </button> */}
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12">
          <div className="bus-filter">
            <div className="row justify-content-center align-items-center g-3">
              <div className="col-md-6 text-start">
                <div className="search-container">
                  <FontAwesomeIcon icon={faSearch} className="search-icon" />
                  <input
                    type="text"
                    className="search-input"
                    placeholder="Search user by name..."
                    value={filters.name}
                    onChange={(e) =>
                      setFilters({ ...filters, name: e.target.value }) ||
                      setPageNumber(1)
                    }
                  />
                </div>
              </div>
              <div className="col-md-6 text-end">
                <h6 className="mb-0">
                  Total Users: {paginationDetails.totalItems || 0}
                </h6>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-12">
          <div className="table table-responsive custom-table management-table">
            <table className="table table-borderless">
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>Profile</th>
                  <th>Name</th>
                  <th>Mobile</th>
                  <th>Gender</th>
                  <th>Marital</th>
                  <th>Created</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {userList.length > 0 ? (
                  userList.map((user, index) => (
                    <tr key={user.id}>
                      <td>{index + 1}</td>
                      <td>
                        <img
                          src={`${baseUrl}/${user?.profile_pic}`}
                          alt="profile"
                          style={{ width: "60px" }}
                        />
                      </td>
                      <td>{user?.name || "N/A"}</td>
                      <td>{user?.mobile_number || "N/A"}</td>
                      <td>{user?.gender || "N/A"}</td>
                      <td>{user?.marital_status || "N/A"}</td>
                      <td>{moment(user?.created).format("lll")}</td>
                      <td>
                        <select
                          className="form-select"
                          value={user?.status}
                          onChange={(e) =>
                            handleStatus(user?.id, e.target.value)
                          }
                          style={{
                            minWidth: "120px",
                            textTransform: "capitalize",
                          }}
                        >
                          <option value="Active">Active</option>
                          <option value="Inactive">Inactive</option>
                          <option value="Pending">Pending</option>
                        </select>
                      </td>
                      <td>
                        <div className="action-buttons">
                          <Link
                            to={`/user-view/${user?.id}`}
                            className="action-btn edit-btn"
                          >
                            <i className="fa fa-eye"></i>
                            <span className="tooltip-text">View</span>
                          </Link>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center">
                      No users found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {totalPages > 1 && (
              <Pagination
                pageNumber={pageNumber}
                setPageNumber={setPageNumber}
                pageLimit={pageLimit}
                paginationDetails={paginationDetails}
                totalPages={paginationDetails.totalPages}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
